import Navigation from './Navigation';

export default function DrawerContent() {
  return (
    <div
      className="flex flex-col overflow-y-auto overflow-x-hidden"
      style={{ flex: 1, height: 'calc(100vh - 112px)' }}
    >
      <Navigation />
    </div>
  );
}
